/* External */
import { memo, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

/* Components */
import Show from './Show';
import Vod from './Vod';
import Live from './Live';
import Section from './Section';

/* Utils */
import { getPath, Routes, RouteShape } from '../../../utils/router';
import { useLoading } from '../../../providers/LoadingProvider';
import { PROVIDERS } from '../../../utils/constants';

function Detail({ parentRoute, sourceProvider }) {
  const { hideLoading } = useLoading();

  useEffect(() => {
    hideLoading();
  }, [hideLoading]);

  return (
    <Switch>
      <Route path={getPath(parentRoute.Vod)}>
        <Vod sourceProvider={sourceProvider} />
      </Route>
      <Route path={getPath(parentRoute.Show)}>
        <Show sourceProvider={sourceProvider} />
      </Route>
      <Route path={getPath(parentRoute.Live)}>
        <Live sourceProvider={sourceProvider} />
      </Route>
      <Route path={getPath(parentRoute.Section)}>
        <Section sourceProvider={sourceProvider} />
      </Route>
    </Switch>
  );
}

Detail.propTypes = {
  parentRoute: PropTypes.shape({
    Vod: RouteShape.isRequired,
    Show: RouteShape.isRequired,
    Live: RouteShape.isRequired,
    Section: RouteShape.isRequired,
  }),
  sourceProvider: PropTypes.string,
};

Detail.defaultProps = {
  parentRoute: Routes.Private.Detail,
  sourceProvider: PROVIDERS.VRIO,
};

export default memo(Detail);
